import api from "./api"; 

export const getAllResources = async () => {
  try {
    const url = `resource-management/`;

    const response = await api.get(url);

    if (response.status === 200 && response.data?.data) {
      return {
        success: true,
        data: response.data?.data,
      };
    } else {
      console.error("Failed to fetch resources:", response);
      return {
        success: false,
        error: "Failed to fetch resources",
      };
    }
  } catch (error) {
    console.error(
      "Get Resources Error:",
      error.response?.data?.data || error.message
    );

    return {
      success: false,
      error:
        error.response?.data?.data?.detail ||
        "Could not fetch resources",
    };
  }
};